import Immutable from 'immutable';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getCurrentScope, getDefaultScope, getRootScope } from 'app/helpers/search/scopes';
import { selectCatalogSearch } from 'app/selectors/SearchSelector';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';

const useSearchScopes = () => {
  const catalogSearch = useSelector(selectCatalogSearch);
  const scopes = useSelector(selectCurrentSiteScopes, Immutable.List());

  const currentScopeId = catalogSearch.get('scope');

  const [state, setState] = useState({
    currentScope: getCurrentScope(scopes?.toJS(), currentScopeId),
    defaultScope: getDefaultScope(scopes?.toJS()),
    rootScope: getRootScope(scopes?.toJS()),
    scopes: scopes?.toJS()
  });

  useEffect(() => {
    setState(prevState => {
      return {
        ...prevState,
        currentScope: getCurrentScope(scopes?.toJS(), currentScopeId),
        defaultScope: getDefaultScope(scopes?.toJS()),
        rootScope: getRootScope(scopes?.toJS())
      };
    });
  }, [currentScopeId, scopes]);

  return state;
};

export default useSearchScopes;
